import React, { createContext, useContext, Dispatch, SetStateAction } from 'react'
import useAsyncStorageState from '@hooks/useAsyncStorageState'

interface ProviderProps {
  children: JSX.Element | JSX.Element[]
}

interface DefaultValue {
  localPendingWorkOrders: WorkOrderRequest[]
  saveLocalPendingWorkOrder: (workOrder: WorkOrderRequest) => void
  setLocalPendingWorkOrders: Dispatch<SetStateAction<WorkOrderRequest[]>>
}

const defaultValue: DefaultValue = {
  localPendingWorkOrders: [],
  saveLocalPendingWorkOrder: () => {},
  setLocalPendingWorkOrders: () => {},
}

const PendingWorkOrdersContext = createContext(defaultValue)

export const usePendingWorkOrders = () => useContext(PendingWorkOrdersContext)

export const PendingWorkOrdersProvider = ({ children }: ProviderProps) => {
  const [pendingWorkOrders, setPendingWorkOrders] =
    useAsyncStorageState<WorkOrderRequest[]>('pendingWorkOrders', [])

  const saveLocalPendingWorkOrder = (workOrder: WorkOrderRequest) => {
    setPendingWorkOrders([
      ...(pendingWorkOrders || []),
      workOrder,
    ])
  }

  return (
    <PendingWorkOrdersContext.Provider
      value={{
        localPendingWorkOrders: pendingWorkOrders,
        saveLocalPendingWorkOrder,
        setLocalPendingWorkOrders: setPendingWorkOrders,
      }}
    >
      { children }
    </PendingWorkOrdersContext.Provider>
  )
}
